import axios from "../../../axiosClient";

export const getLuminanceProfile = async (
  pageSize: any,
  PageNumber: any,
  SortBy: any,
  SortDirection: any,
  id: any
) => {
  const body = {
    pageSize,
    PageNumber,
    SortBy,
    SortDirection,
  };
  const res = await axios.get(`/slpapp/LuminanceProfile/GetLuminanceProfile`, {
    params: { assetCode: id, ...body },
  });

  return res?.data;
};
